export enum BrowserType {
  MSEDGE = "Microsoft Edge",
  CHROME = "Google Chrome",
  FIREFOX = "Mozilla Firefox",
  SAFARI = "Safari",
  IEXPLORER = "Internet Explorer",
  UNKONWN = "Unknown Browser"
}

/**
 * function to detech what browser the user is using
 * @returns name of browser what user uses
 */
export function getBrowser(userAgent: string): BrowserType {
  if (userAgent.includes("Chrome")) {
    if (userAgent.includes("Edg")) {
      return BrowserType.MSEDGE; // "Microsoft Edge"; // Edge uses Chromium engine
    }
    return BrowserType.CHROME; // "Google Chrome";
  }
  if (userAgent.includes("Firefox")) {
    return BrowserType.FIREFOX; // "Mozilla Firefox";
  }
  if (userAgent.includes("Safari")) {
    if (!userAgent.includes("Chrome")) {
      return BrowserType.SAFARI; // "Safari"; // Safari's user agent does not include 'Chrome'
    }
  }
  if (userAgent.includes("Edge")) {
    return BrowserType.MSEDGE; // "Microsoft Edge";
  }
  if (userAgent.includes("Trident")) {
    return BrowserType.IEXPLORER; // "Internet Explorer";
  }
  return BrowserType.UNKONWN; // "Unknown Browser";
}
